import { render, staticRenderFns } from "./PathwayCohortEditModal.vue?vue&type=template&id=be23a968&"
import script from "./PathwayCohortEditModal.vue?vue&type=script&lang=js&"
export * from "./PathwayCohortEditModal.vue?vue&type=script&lang=js&"
import style0 from "./PathwayCohortEditModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports